<div class="modal-header">
  <h4 class="modal-title">{{'parkingBooking.form.title' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <i class="ico-close sz-xs"></i>
  </button>
</div>

<ng-template #noCredentials>
  <div class="modal-body">
    <h6>
      {{'parkingBooking.boschUnauthorizedClient' | translate}}
      {{vehicleOwnerTitle}}
      {{'parkingBooking.boschUnauthorizedClientExplain' | translate}}
    </h6>
    <div>
      {{'parkingBooking.visit' | translate}}
      <a [href]="'https://www.l-os.com/eu/en'" target="_blank">Bosch Logistics Operating System</a>
    </div>
    <div>
      {{'parkingBooking.email' | translate}}
      <a [href]="'mailto:hello.l-os@bosch.com'">hello.l-os@bosch.com</a>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="hasCredentials; else noCredentials">
  <div class="modal-body">
    <div *ngIf="parkingInfo && bookingInfo == null">
      <h6 class="parking-name">{{parkingInfo.name}}</h6>
      <p>{{parkingInfo.description}}</p>
      <div>
        {{'parkingBooking.form.fees' | translate}}
        <strong>{{parkingInfo.fees}}</strong>
      </div>
      <div>
        {{'parkingBooking.form.hours' | translate}}
        <strong>{{parkingInfo.openingHours}}</strong>
      </div>
      <hr/>
    </div>
    <form *ngIf="bookingForm && bookingInfo == null" [formGroup]="bookingForm" class="booking-form">
      <section class="form__columns fc-3">
        <div class="form-group fc_c--required">
          <label for="startDate">{{'parkingBooking.form.start' | translate}}</label>
          <app-date-time-picker id="startDate"
                                [pickerType]="'DATE_TIME'"
                                [placement]="'bottom'"
                                [minDate]="minDate"
                                [form]="bookingForm"
                                [controlName]="'startDate'">
          </app-date-time-picker>
          <app-control-messages [control]="bookingForm.controls.startDate"></app-control-messages>
        </div>
        <div class="form-group hour-select text-center fc_c--labelless">
          <div class="switch">
            <ng-container *ngFor="let hour of defaultHours">
              <a class="switch__item" (click)="setEnd(hour)" tabindex="1">{{hour}}</a>
            </ng-container>
          </div>
        </div>
        <div class="form-group fc_c--required">
          <label for="endDate">{{'parkingBooking.form.end' | translate}}</label>
          <app-date-time-picker id="endDate"
                                [pickerType]="'DATE_TIME'"
                                [placement]="'bottom'"
                                [minDate]="minDate"
                                [form]="bookingForm"
                                [controlName]="'endDate'">
          </app-date-time-picker>
          <app-control-messages [control]="bookingForm.controls.endDate"></app-control-messages>
        </div>
        <div class="form-group fc_c--required">
          <label for="firstName">{{'parkingBooking.form.firstName' | translate}}</label>
          <input maxlength="255" formControlName="firstName" type="text" class="form-control" id="firstName">
          <app-control-messages [control]="bookingForm.controls.firstName"></app-control-messages>
        </div>
        <div class="form-group">
          <label for="lastName">{{'parkingBooking.form.lastName' | translate}}</label>
          <input maxlength="255" formControlName="lastName" type="text" class="form-control" id="lastName">
          <app-control-messages [control]="bookingForm.controls.lastName"></app-control-messages>
        </div>
        <div class="form-group fc_c--required">
          <label for="licensePlate">{{'parkingBooking.form.licensePlate' | translate}}</label>
          <input maxlength="255" formControlName="licensePlate" type="text" class="form-control" id="licensePlate">
          <app-control-messages [control]="bookingForm.controls.licensePlate"></app-control-messages>
        </div>
      </section>
      <div *ngIf="parkingPricing">
        <hr/>
        <div>
          {{'parkingBooking.form.availableSpots' | translate}}
          <strong>{{parkingPricing.availableSpaces}}
          <i [class]="parkingPricing.available ? 'ico-check-square c-green' : 'ico-cross-square c-red'"></i></strong>
        </div>
        <div>
          {{'parkingBooking.form.totalAmount' | translate}}
          <strong>{{parkingPricing.netPrice + ' ' + parkingPricing.currency}}</strong>
        </div>
        <div>
          {{'parkingBooking.form.accessTypes' | translate}}
          <strong *ngFor="let accessType of parkingPricing.accessTypeKeys; last as isLast">
            {{('parkingBooking.form.accessType.' + accessType) | translate}}
            {{!isLast ? '/ ' : ''}}
          </strong>
        </div>
      </div>
    </form>
    <div *ngIf="bookingInfo">
      <h6 class="parking-name">{{bookingInfo.parkingName}}</h6>
      <p>{{bookingInfo.address}}</p>
      <div>
        {{'parkingBooking.form.date' | translate}}
        <strong>{{bookingInfo.startDate + ' - ' + bookingInfo.endDate}}</strong>
      </div>
      <div>
        {{'parkingBooking.form.totalAmount' | translate}}
        <strong>{{bookingInfo.totalAmount?.toFixed(2) + ' ' + bookingInfo.currency}}</strong>
      </div>
      <p>
        {{'parkingBooking.status.title' | translate}}:
        <strong>{{'parkingBooking.status.' + bookingInfo.state | translate}}</strong>
      </p>
      <ng-container *ngFor="let accessInfo of bookingInfo.accessInfo">
        <div *ngIf="accessInfo.accessTypeKey === 'LINK'">
          {{'parkingBooking.form.reservationLink' | translate}}
          <strong><a [href]="accessInfo.value" target="_blank">{{accessInfo.value}}</a></strong>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="bookingId != null && bookingInfo?.state === 'ACTIVE'" class="modal-footer">
    <button type="button"
            class="form__action--danger"
            role="button"
            (appOperationConfirm)="cancelBooking()">
      <i class="ico-trash"></i>
      {{'parkingBooking.actions.cancel' | translate}}
    </button>
  </div>

  <div *ngIf="bookingId == null" class="modal-footer">
    <button type="button"
            class="form__action--secondary"
            role="button"
            [disabled]="!bookingForm?.valid
                      || (previousStart === bookingForm?.value.startDate && previousEnd === bookingForm?.value.endDate)"
            (click)="checkPricing()">
      <i class="ico-search"></i>
      {{'parkingBooking.actions.availability' | translate}}
    </button>
    <button type="button"
            class="form__action--primary"
            role="button"
            [disabled]="!bookingForm?.valid || !parkingAvailable"
            (appOperationConfirm)="bookParking()">
      <i class="ico-check"></i>
      {{'parkingBooking.actions.confirm' | translate}}
    </button>
    <button type="button" class="form__action--tertiary" role="button" (click)="closeModal()">
      <i class="ico-close"></i>
      {{'button.cancel' | translate}}
    </button>
  </div>
</ng-container>
